<template>
    <v-container align-start>
        <v-form
            class="form-lost"
            v-model="valid"
            ref="form"
            @submit.native.prevent="next"
        >
            <v-layout>
                <v-flex xs12>
                    <v-text-field
                        v-model="account"
                        solo
                        :label="lang.password_lost_account_placeholder"
                        :disabled="pageLoading"
                        :rules="rules"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <verification-code
                v-model="code"
                :params="{}"
                type="image"
                :error="isErrCode"
                :disabled="!isAccountValid || isErrValue"
            ></verification-code>
            <v-btn
                block
                :disabled="!valid"
                class="btn-h48"
                color="primary"
                @click="next"
            >
                {{ lang.next_step_text }}
            </v-btn>
        </v-form>
    </v-container>
</template>
<script>
import VerificationCode from "@/components/VerificationCode";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
    name: "Lost",
    components: {
        VerificationCode
    },
    data() {
        return {
            valid: false,
            account: "",
            code: "",
            isErrValue: false,
            isErrCode: false
        };
    },
    computed: {
        ...mapState(["pageLoading", "params"]),
        ...mapGetters(["lang"]),
        isAccountValid() {
            return true;
        },
        rules() {
            let tmp = [];
            tmp.push(v => !v && this.lang.empty_lost_account_tips);
            tmp.push(
                () => this.isErrValue && this.lang.iscorrect_lost_account_tips
            );
            return tmp;
        }
    },
    watch: {
        code(val) {
            if (val) {
                this.isErrCode = false;
            }
        },
        account() {
            this.isErrValue = false;
        }
    },
    methods: {
        ...mapActions(["verifyAccount"]),
        ...mapMutations({
            changePageLoading: "CHANGE_PAGE_LOADING"
        }),
        next() {
            if (this.pageLoading) {
                return;
            }
            this.changePageLoading(true);
            this.verifyAccount({
                identifer: this.account,
                captcha: this.code
            })
                .then(() => {
                    this.$router.push({
                        name: "security",
                        query: Object.assign({}, this.params, {
                            redirect: "reset",
                            t: Date.now()
                        })
                    });
                })
                .catch(err => {
                    if (err.code === 1001) {
                        this.isErrCode = true;
                    } else if (err.code === 1002) {
                        this.isErrCode = true;
                        this.isErrValue = true;
                    }
                    setTimeout(() => {
                        this.changePageLoading(false);
                        this.$refs.form.validate();
                    }, 300);
                });
        }
    }
};
</script>
